import logo from '@/assets/owla-logo.svg';

export default function Footer({ t }) {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <img src={logo} alt="Owla" />
          <span className="footer-wordmark">Owla</span>
          <span className="footer-divider" />
          <span className="footer-by">{t.by} · 2026</span>
        </div>
        <div className="footer-links">
          <a href="/">{t.home}</a>
          <a href="/docs">{t.docs}</a>
          <a href="/support">{t.support}</a>
          <a href="/privacy-policy">{t.privacy}</a>
          <a href="https://www.goldenowl.asia" target="_blank" rel="noopener noreferrer">Golden Owl</a>
        </div>
      </div>
    </footer>
  );
}
